<template>
  <div class="container">
    <HMModalHeader
      :title="$t('COMMUNITY.TITLE.EDIT_COMMENT')"
      @close="onDiscard"
    />
    <div>
      <CommunityCompose
        :id="`edit-block__${comment.id}`"
        :numberId="comment.id"
        class="community-compose mb-4"
        :user="user"
        :editText="editText"
        :initialAttachment="getAttachment(comment)"
        @editComment="onConfirm"
        :attachmentProp="attachment"
        :allowScheduling="allowScheduling"
        :releaseOnProp="releaseOnDate"
        :hashtagsEnabled="hashtagsEnabled"
        :hashtags="hashtags"
        :initialHashtag="comment.hashtag"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommunityCompose from '@/web/components/community/CommunityCompose';
import { pick } from 'lodash';
import moment from 'moment';

export default Vue.extend({
  name: 'CommunityCommentEditModal',
  components: {
    CommunityCompose,
  },
  props: {
    comment: Object,
    user: Object,
    editText: String,
    confirm: null,
    allowScheduling: {
      type: Boolean,
      default: false,
    },
    hashtagsEnabled: {
      type: Boolean,
    },
    hashtags: {
      type: Array,
    },
  },
  computed: {
    attachment() {
      return {
        attachment_type: this.comment.attachment_type,
        attached_description: this.comment.attached_description,
        attached_favicon_url: this.comment.attached_favicon_url,
        attached_title: this.comment.attached_title,
        attached_url: this.comment.attached_url,
        attached_image: this.comment.attached_image,
      };
    },
    releaseOnDate() {
      if (!this.comment?.release_on) return null;

      return moment(this.comment.release_on).toDate();
    },
  },
  methods: {
    onConfirm(comment) {
      this.confirm(comment);
      this.$emit('close');
    },
    onDiscard() {
      if (this.discard) {
        this.discard();
      }
      this.$emit('close');
    },
    getAttachment(comment) {
      return pick(comment, [
        'attachment_type',
        'attached_image',
        'attached_title',
        'attached_description',
        'attached_url',
        'attached_favicon_url',
      ]);
    },
  },
});
</script>
